import { create } from "zustand";
import { analyticsApi, deleteVendor, dowloadvendorlist, getAllVendorFunction, getVendorapi, getVendorByIdFunction, postVendor } from "../api/vendor";


export const useVendorStore = create((set, get) => ({
    vendor: [],
    loading: false,
    selectedVendor: null,
    nonPaginatedVendor: [],

    getVendor: async () => {
        set({ loading: true })
        try {
            const res = await getVendorapi()
            console.log("vendor", res)
            set({ loading: false, nonPaginatedVendor: res })
        } catch (error) {
            console.error("Login failed:", error);
            set({ loading: false });
            throw error;
        }
    },
    getAllVendor: async (pageNumber, pageSize, search, field) => {
        set({ loading: true })
        try {
            const res = await getAllVendorFunction(pageNumber, pageSize, search, field)
            console.log("getAllVendor", res)
            set({ loading: false, vendor: res?.ref })
            return res
        } catch (error) {
            console.error("Login failed:", error);
            set({ loading: false });
            throw error;
        }
    },
    getVendorById: async (id) => {
        set({ loading: true })
        try {
            const res = await getVendorByIdFunction(id)
            set({ loading: false })
            return res
        } catch (error) {
            console.error("vendor fetched:", error);
            set({ loading: false });
            throw error;
        }
    },
    addvendor: async (formData, id) => {
        set({ loading: true })
        try {
            const res = await postVendor(formData, id)
            set({ loading: false })
        } catch (error) {
            console.error("Login failed:", error);
            set({ loading: false });
            throw error;
        }
    },
    deletevendor: async (id) => {
        try {
            set({ loading: true })
            const res = await deleteVendor(id)
            const currentVendor = get().vendor || [];
            const updatedVendor = currentVendor.filter((ele) => ele._id !== id);
            set({ loading: false, vendor: updatedVendor });
        } catch (err) {
            console.log("Internal server error:", err);
            set({ category: null });
            return false;
        }
    },
    getAnalytics: async () => {
        set({ loading: true })
        try {
            const res = await analyticsApi()
            set({ loading: false })
            return res
        } catch (error) {
            console.error("Login failed:", error);
            set({ loading: false });
            throw error;
        }
    },
    dowloadVendorList: async (pageNumber, pageSize, search, field) => {
        try {
            set({ loading: true })
            const res = await dowloadvendorlist(pageNumber, pageSize, search, field)
            set({ loading: false })
            return res
        } catch (error) {
            console.log("Internal server error:", error);
            set({ category: null });
            return false;
        }
    },
}))